export default __webpack_public_path__ + "static/media/Carregamento Cheia.82a5e146.svg";